import { render, staticRenderFns } from "./index-news.vue?vue&type=template&id=448aa66e&scoped=true&"
import script from "./index-news.vue?vue&type=script&lang=js&"
export * from "./index-news.vue?vue&type=script&lang=js&"
import style0 from "./index-news.vue?vue&type=style&index=0&id=448aa66e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448aa66e",
  null
  
)

export default component.exports